import { UPGRADE_MODAL_DISMISSED_COOKIE } from '@shared/constants/StorageValues';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import AlertsContainer from './state/AlertsContainer';
import AuthContainer from './state/AuthContainer';
import CurrentDeviceContainer from './state/CurrentDeviceContainer';
import CurrentUserContainer from './state/CurrentUserContainer';
import DeviceContainer from './state/DeviceContainer';
import GlobalCustomControlsContainer from './state/GlobalCustomControlsContainer';
import ProfilesContainer from './state/ProfilesContainer';
import PublicProfilesContainer from './state/PublicProfilesContainer';

export default function useSignout() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const alertsContainer = AlertsContainer.useContainer();
    const authContainer = AuthContainer.useContainer();
    const currentUserContainer = CurrentUserContainer.useContainer();
    const deviceContainer = DeviceContainer.useContainer();
    const currentDeviceContainer = CurrentDeviceContainer.useContainer();
    const profilesContainer = ProfilesContainer.useContainer();
    const publicProfileContainer = PublicProfilesContainer.useContainer();
    const globalCustomControlsContainer = GlobalCustomControlsContainer.useContainer();
    const [isShowingSignoutConfirmation, setIsShowingSignoutConfirmation] = useState<boolean>(false);

    const hideSignoutConfirmation = useCallback(() => {
        setIsShowingSignoutConfirmation(false);
    }, []);

    const showSignoutConfirmation = useCallback(() => {
        setIsShowingSignoutConfirmation(true);
    }, []);

    const clearAndReload = useCallback(() => {
        // Perform all necessary cleanup operations
        authContainer.logout();
        deviceContainer.clearDevices();
        currentDeviceContainer.clearAll();
        profilesContainer.clearProfiles();
        publicProfileContainer.clearProfiles();
        currentUserContainer.clearCurrentUser();
        globalCustomControlsContainer.clear();
        // Clear upgrade modal dismissal so it shows again on next login
        localStorage.removeItem(UPGRADE_MODAL_DISMISSED_COOKIE);
        navigate('../login');
        window.location.reload(); // Reload the page to ensure all changes take effect
    }, []);

    const signout = async () => {
        console.log('signout');
        // remove everything from local storage, navigate to home page, refresh page
        // delete virtual device then clear
        authContainer.handleIsLoading(true);
        hideSignoutConfirmation();
        if (deviceContainer.virtualDeviceIdRef.current) {
            try {
                const result = await deviceContainer.disableDevice(deviceContainer.virtualDeviceIdRef.current);
                if (result?.resultType != 'Ok') {
                    alertsContainer.showError(t('common:device.error.deleteLong'));
                }
            } catch (error) {
                alertsContainer.showError(t('common:device.error.deleteLong'));
            }
        }
        clearAndReload();

        authContainer.handleIsLoading(false);
    };
    return {
        signout,
        isSignOutConfirmationVisible: isShowingSignoutConfirmation,
        showSignoutConfirmation,
        hideSignoutConfirmation,
        clearAndReload,
    };
}
